var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFinanceStep02 = function SvgIconFinanceStep02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 120,
    width: 120,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-787-156H653v789H-787z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.957 13.079v4.068H33.649v3.211h-4.182v4.84l-.316-.41h-4.183v87.793h68.983v-3.96l-.364-.47h4.862v-3.962h2.682V17.147H77.824v-4.068z",
    fill: "#cfdde9"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#051a2d",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.684 38.07h35.651v-4.155H48.684z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.84 98.986h2.683V11.943H72.215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.04 15.154v83.832h64.8m-64.8-83.832v-3.21h23.308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.04 15.154h-4.183v87.793H92.84v-3.961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.264 40.067h8.45v-8.451h-8.45zm11.42 13.617h35.651v-4.155H48.684zm-11.42 1.997h8.45V47.23h-8.45zm11.42 13.617h35.651v-4.154H48.684zm-11.42 1.998h8.45v-8.452h-8.45zm11.42 13.616h35.651v-4.154H48.684zm-11.42 1.998h8.45v-8.451h-8.45zm14.084-71.756v-3.21m0-.001V7.875h20.867v4.068m0 0v3.211m-20.867 0v.858h20.867v-.858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.892 19.362h-4.016v87.792H86.12v-3.961"
  })))));
};
export default SvgIconFinanceStep02;